import * as util from '@/common/util'

/**
 * Global filters for formatting dates and times
 */
const globalFilter = {
  /**
   * Formats a date value to yyyy-MM-dd format
   * @param value - The date value (Date object, date string, or timestamp)
   * @returns The formatted date string in yyyy-MM-dd format
   * @example
   * formatDate(new Date()) // '2024-01-15'
   * formatDate('2024-01-15T10:30:00') // '2024-01-15'
   */
  formatDate(value: Date | string | number): string {
    return util.formatDate.format(new Date(value), 'yyyy-MM-dd')
  },
  /**
   * Formats a date value to yyyy-MM-dd hh:mm format
   * @param value - The date value (Date object, date string, or timestamp)
   * @returns The formatted date string in yyyy-MM-dd hh:mm format
   * @example
   * formatDateTime(new Date()) // '2024-01-15 14:30'
   * formatDateTime('2024-01-15T14:30:00') // '2024-01-15 14:30'
   */
  formatDateTime(value: Date | string | number): string {
    return util.formatDate.format(new Date(value), 'yyyy-MM-dd hh:mm')
  },
  /**
   * Formats a date value to yyyy-MM-dd hh:mm:ss format
   * @param value - The date value (Date object, date string, or timestamp)
   * @returns The formatted date string in yyyy-MM-dd hh:mm:ss format
   * @example
   * formatDateTimeSeconds(new Date()) // '2024-01-15 14:30:45'
   * formatDateTimeSeconds('2024-01-15T14:30:45') // '2024-01-15 14:30:45'
   */
  formatDateTimeSeconds(value: Date | string | number): string {
    return util.formatDate.format(new Date(value), 'yyyy-MM-dd hh:mm:ss')
  },
  /**
   * Formats a date value to yyyy-MM-dd hh:mm:ss format with microseconds
   * Handles ISO date strings with microseconds and ensures 4-digit microsecond precision
   * @param value - The date value (Date object, date string, or timestamp)
   * @returns The formatted date string in yyyy-MM-dd hh:mm:ss mmmm format (where mmmm is microseconds)
   * @example
   * formatDateTimeLong('2024-01-15T14:30:45.123Z') // '2024-01-15 14:30:45 1230'
   * formatDateTimeLong('2024-01-15T14:30:45.12Z') // '2024-01-15 14:30:45 1200'
   */
  formatDateTimeLong(value: Date | string | number): string {
    const valueStr = String(value)
    const times = valueStr.split('.')
    let microseconds = times[1] || ''
    microseconds = microseconds.replace('Z', '')
    const shortLength = 4 - microseconds.length
    for (let i = 0; i < shortLength; i++) {
      microseconds += '0'
    }
    microseconds = microseconds.substring(0, 4)
    const d = new Date(value)
    return util.formatDate.format(d, 'yyyy-MM-dd hh:mm:ss') + ' ' + microseconds
  }
}

export default globalFilter
